import "./css/ModalPopup.css";
import { FaTimesCircle, FaWindowClose } from "react-icons/fa";

const ModalPopup = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title} <div style={{ float : "right" }} > <FaWindowClose className="edit-icon"  onClick={onClose} /> </div> </h3>          
        </div>

        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalPopup;




/*
const ModalPopup = ({ isOpen, title, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <span className="close-btn" onClick={onClose}>×</span>
        </div>

        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ModalPopup;
*/